function days_between(START_DATE, END_DATE) {
	//如果上传的日期是20200203这种格式那么需要转换成2020-02-03格式
	// var sdate = START_DATE.substr(0, 4) + '-'+START_DATE.substr(4, 2)  + '-'+ START_DATE.substr(6, 2);
	// var edate = END_DATE.substr(0, 4) + '-'+END_DATE.substr(4, 2)  + '-'+ END_DATE.substr(6, 2);
	var sdate = START_DATE;
	var edate = END_DATE;
	var sdate1 = Date.parse(sdate);
	var edate1 = Date.parse(edate);
	//取两个数相差的绝对值    
	var timeDiff = Math.abs(edate1 - sdate1);
	// alert(timeDiff)
	//计算相差天数
	var cdate = Math.ceil(timeDiff / (1000 * 3600 * 24));
	return cdate;
}

/**
 *  创建日期离今天有3天就返回true ,否则返回false
 *   传入 创建日期
 *   返回  布尔值
 */

function  kz(sj) {
	// alert(sj) // 2021-11-13 20:02:52
	var createTime = sj
	var date = new Date();
	var dateString = date.toISOString().replace(/T.*/, ' ') + date.toLocaleTimeString().replace(/ G.*/, "")
	var START_DATE = createTime.substr(0, 10)
	var END_DATE = dateString.substr(0, 10)
	// alert(END_DATE)
	var num = days_between(START_DATE, END_DATE)
	// alert("num="+num)
	if (num > 30) {
		return true
	} else {
		return false
	}

}


function  kz90(sj) {
	// alert(sj) // 2021-11-13 20:02:52
	var createTime = sj
	var date = new Date();
	var dateString = date.toISOString().replace(/T.*/, ' ') + date.toLocaleTimeString().replace(/ G.*/, "")
	var START_DATE = createTime.substr(0, 10)
	var END_DATE = dateString.substr(0, 10)
	// alert(END_DATE)
	var num = days_between(START_DATE, END_DATE)
	// alert("num="+num)
	if (num > 30) {
		return true
	} else {
		return false
	}

}

function  kz1(sj) {
	// alert(sj) // 2021-11-13 20:02:52
	var createTime = sj
	var date = new Date();
	var dateString = date.toISOString().replace(/T.*/, ' ') + date.toLocaleTimeString().replace(/ G.*/, "")
	var START_DATE = createTime.substr(0, 10)
	var END_DATE = dateString.substr(0, 10)
	// alert(END_DATE)
	var num = days_between(START_DATE, END_DATE)
	// alert("num="+num)
	if (num > 0) {
		return true
	} else {
		return false
	}

}

// 金额添加千分位
function numberAddCommas(num = 0, len = 3) {
  let [str, dot] = String(num).split(".");
  const arr = str.split(/([+-])/);
  let symbol = "";
  let res = "";
  if (arr.length > 1) {
    symbol = arr[1];
    str = arr[2];
  }
  while (str.length > len) {
    res = `,${str.slice(-len)}${res}`;
    str = str.slice(0, str.length - len);
  }
  if (str) {
    res = str + res;
  }
  return dot ? `${symbol}${res}.${dot}` : `${symbol}${res}`;
}


/**
 * 金额转成万为单位
 * 如果小于1万则返回 xx.xxxx万
 * 如果大于等于1万则返回 xx.xx万
 * 如果等于0则返回 0
 * @param {number|string} amount 金额
 * @returns {string} 转换后的字符串
 */
function amountToWan(amount) {
  const num = Number(amount);
  if (isNaN(num)) return '0';
  if (num === 0) return '0';
  const wan = num / 10000;
  // 小于1万保留四位小数，否则保留两位
  return wan < 1 ? `${wan.toFixed(4)}万元` : `${wan.toFixed(2)}万元`;
}






export {
	kz,
	kz90,
	kz1,
	numberAddCommas,
	amountToWan
};


